<nav top [isSpanish]="isSpanishPage"></nav>
<nav navigation-bar [isWhiteNav]="isWhiteNav" [isSpanish]="isSpanishPage"></nav>